 

import shape from "../../assets/images/all-img/blog2/shape.png";
import shape2 from "../../assets/images/all-img/v3/shape2.png";
import BreadcrumbSection from "./breadcrumb-section";
import ContactSection from "./contact-section";

export default function InnerSection() {
	return (
		<div className="fugu--inner-section dark-version">
			<div className="container">
				<BreadcrumbSection />
				<ContactSection />
			</div>
			<div className="fugu--blog-shape1">
				<img src={shape2} alt="" />
			</div>
			<div className="fugu--blog-shape3">
				<img src={shape} alt="" />
			</div>
		</div>
	);
}
